/** Shared styling for Veersa Points markers on forms (purple brand #3C3489). */

export const veersaPointsChipSx = {
  fontWeight: 700,
  flexShrink: 0,
  backgroundColor: "#ede9fe",
  color: "#4c1d95",
  border: "1px solid #c4b5fd",
  "& .MuiChip-label": { px: 1 },
};

export const veersaPointsBannerSx = {
  display: "flex",
  alignItems: "flex-start",
  gap: 1.25,
  mt: 0.5,
  mb: 1,
  p: 1.5,
  borderRadius: 1,
  background: "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 55%, #e9e4f6 100%)",
  border: "1px solid #c4b5fd",
};
